<div class="modal-header">
    <div class="row">
        <div class="col-2">
            <app-branding-logo-display [useDefaultLogo]="true"></app-branding-logo-display>
        </div>
        <div class="col-8 text-center">
            <h4 class="modal-title"><b>Proof Of Delivery</b></h4>
        </div>
        <div class="col-2">
            <div class="text-end"><button type="button" class="btn btn-outline-secondary"
                    (click)="activeModal.close('Close click')">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal-body">

    @if(isLoading || !containerJobPodData){
    <h4>
        Loading...
    </h4>
    }@else{
    <div class="eye-view-grid-wrapper">
        <div class="row">
            <div class="col-6 mb-2">
                <h5><strong>Consignee Details</strong></h5>
                <div class="row eye-view-consignor-row">
                    <div class="col-3 mogo-bold eye-view-consignor-header">
                        Name
                    </div>
                    <div class="col-9 eye-view-consignor-content">
                        {{ containerJobPodData.toAddressName}}
                    </div>
                </div>
                <div class="row eye-view-consignor-row">
                    <div class="col-3 mogo-bold eye-view-consignor-header">
                        Address
                    </div>
                    <div class="col-9 eye-view-consignor-content">
                        {{ containerJobPodData.toAddress}}
                    </div>
                </div>
                <div class="row ">
                    <div class="col-3 mogo-bold eye-view-consignor-header">
                        &nbsp;
                    </div>
                    <div class="col-9 eye-view-consignor-content">
                        &nbsp;
                    </div>
                </div>
                <div class="row ">
                    <div class="col-3 mogo-bold eye-view-consignor-header">
                        Truck
                    </div>
                    <div class="col-9 eye-view-consignor-content">
                        {{containerJobPodData.truckCode}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-3 mogo-bold eye-view-consignor-header">
                        Complted By
                    </div>
                    <div class="col-9 eye-view-consignor-content">
                        {{containerJobPodData.driverName }}
                    </div>
                </div>
            </div>
            <div class="col-6 mb-2">
                <h5><strong>Delivery Details</strong></h5>
                <div class="row eye-view-consignor-row">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        Delivered
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{containerJobPodData.deliveredDateTime}}
                    </div>
                </div>
                <div class="row eye-view-consignor-row">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        Job Type
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{containerJobPodData.jobType}}
                    </div>
                </div>
                <div class="row ">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        Order Number
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{containerJobPodData.orderNumber}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        Reference Number
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{containerJobPodData.customerReference}}
                    </div>
                </div>
                <div class="row ">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        Status
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{containerJobPodData.status}}
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 mb-4">
            <h5><strong>Container Details</strong></h5>
            <table class="table">
                <thead>
                    <tr>
                        <th class="mogo-bold mogo-bg-lightgray">
                            Container Number
                        </th>
                        <th class="mogo-bold mogo-bg-lightgray">
                            Container Type
                        </th>
                        <th class="mogo-bold mogo-bg-lightgray">
                            Container Size
                        </th>
                        <th class="mogo-bold mogo-bg-lightgray">
                            Weight (kg)
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td>{{ containerJobPodData.containerNumber }}</td>
                        <td>{{ containerJobPodData.containerType }}</td>
                        <td>{{ containerJobPodData.containerSize }}</td>
                        <td>{{ containerJobPodData.containerWeight }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        @if(containerJobPodData && containerJobPodData.toAddressLatitude && containerJobPodData.toAddressLongitude){
        <div class="col-12 mb-2">
            <div #deliverylocationmap id="delivery-location-map" style="height: 200px;"></div>
        </div>
        }
    </div>
    }
</div>
<div class="modal-footer">
    <div class="col-11 flex-fill">
        @if(sendEmailForm !== undefined && sendEmailForm !== null){
        <div class="flex-fill">
            <form [formGroup]="sendEmailForm" class="d-inline-flex w-50">
                <ng-select formControlName="recipients" [items]="[]" [addTag]="addTag" [multiple]="true"
                    [selectOnTab]="true" [isOpen]="false" placeholder="Enter email addresses"
                    notFoundText="Type to add a valid email" class="w-100">
                </ng-select>

                <button class="btn btn-primary" style="margin-left: 10px;" (click)="sendEmail()"
                    [disabled]="emailFormControl.value.length === 0">
                    Send
                </button>
            </form>
            <button type="button" class="btn btn-primary" style="margin-left: 10px;"
                (click)="downloadPodClick()">Download</button>
        </div>
        }

    </div>
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close('Close click')">Close</button>
</div>